<template>
  <el-dialog title="报名表" :visible.sync="innerVisible" width="30%" center>
    <div class="center">
      <h4>当前选择学校</h4>
      <div class="dialog-text">{{ interview.school_name }}</div>
      <el-alert title="如需修改请联系文案或咨询" type="warning" :closable="false"></el-alert>
      <h4>报名表</h4>
      <jm-upload-file
        url="/newfib.php/index/apply_file/upload"
        :upload-data="{ crm_id: interview.user_id }"
        :show-file-list="true"
        :upload-additional="uploadInfo"
      >
        <template slot="uploadFile">
          <div class="dialog-text">原始报名表</div>
          <el-button v-show="false" type="primary" size="medium">上传报名表</el-button>
          <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
        </template>
      </jm-upload-file>

      <jm-asset-upload
        :file-list="fileList"
        @upload-success="uploadSuccess"
        :limit="1"
      >
        <el-button size="small" type="primary">点击上传新报名表</el-button>
      </jm-asset-upload>
      <el-alert
        v-show="interview.is_special"
        title="此学校为非标准报名表，请确保已上传excel报名表"
        type="warning"
        :closable="false"
      ></el-alert>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="btn-close-dialog" type="primary" @click="close">取消</el-button>
      <el-button class="btn-save-dialog" type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { jmSchoolSearch, jmUploadFile, jmAssetUpload } from '@/components/tool';
import dialogMixin from './dialogMixin';

export default {
  name: 'SignupTableDialog',
  mixins: [dialogMixin],
  components: {
    jmSchoolSearch,
    jmUploadFile,
    jmAssetUpload
  },
  props: {
    interview: {
      type: [Object],
      required: true
    }
  },
  data() {
    return {
      school: {},
      uploadInfo: {
        upload_position: '报名表资料',
        upload_type_str: '报名表资料',
        offer_school_id: 0,
        offer_id: 0,
        country_id: 0
      },
      fileList: [],
      updatedData: {}, // 上传数据
    };
  },
  methods: {
    uploadSuccess(data) {
      console.log(data);
      this.updatedData = data;
      this.fileList = [data];
    },
    async confirm() {
      await this.$http._post({
        url: '/interview/plan/setSignUpTable',
        data: {
          id: this.interview.id,
          assetId: this.updatedData.id,
        }
      });
      this.$message.success('保存新的报名表成功');
      this.close();
    },
  },
  watch: {
    'interview.id'() {
      if (this.interview.signup_table) {
        // eslint-disable-next-line camelcase
        const { filename, file_path } = this.interview.signup_table;
        this.fileList = [{ name: filename, url: file_path }];
      }
    },
  },
};
</script>
<style scoped>
.center {
  text-align: center;
}
.center h4 {
  font-size: 20px;
  padding: 25px;
}
.content {
  padding: 20px;
}
</style>
